import { Button, TailwindModal, Typography } from 'components'
import { Images, TypographyTypes } from 'interfaces'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { DialogType, useDialogsStore } from 'stores'
import Cookies from 'universal-cookie'

export const SessionExpiredDialog: React.FC = (): JSX.Element => {
	const navigate = useNavigate()
	const cookies = new Cookies()
	const { isVisible, dialogType, hideDialog } = useDialogsStore()

	const isOpen = isVisible && dialogType === DialogType.SESSION_EXPIRED

	const handleLogout = (): void => {
		const cookiesToRemove = [
			'fullName',
			'organization_id',
			'roles',
			'userId',
			'organization_slug',
			'organization_name',
			'token',
			'isSuperAdmin',
			'organization_logo'
		]

		cookiesToRemove.forEach(cookieName => {
			cookies.remove(cookieName, { path: '/' })
		})

		hideDialog()
		navigate('/login')
	}

	return (
		<TailwindModal
			open={isOpen}
			setOpen={() => null}
			closeOnOverlayTap={false}
			className="w-fit rounded-md p-8"
		>
			<div className="flex flex-col items-center gap-2 text-center">
				<img
					src={Images.womanDoor}
					alt="Session Expired"
					className="w-64 h-auto mb-2"
				/>
				<Typography
					title="Session Expired"
					type={TypographyTypes.h2}
					className="text-blue-primary !font-bold text-base"
				/>
				<p
					className="text-black-1 text-base font-normal font-Inter leading-[20px]
				"
				>
					Your session has ended. Please log in again
					<br />
					to continue using the platform.
				</p>
				<Button
					label="Log In Again"
					onClick={handleLogout}
					className="mt-4 !rounded-full !px-8"
				/>
			</div>
		</TailwindModal>
	)
}

SessionExpiredDialog.defaultProps = {}
